<template>

    <header class="fuid-header">

        <b-container class="container-redo">

            <b-row>

                <b-col cols="12">
                    <h1 class="fuid-hedader__tit">{{ $t('header.h1') }} - {{ $t(`header.${codigoTraduccion}`) }}</h1>
                    <p class="fuid-header__text">{{ $t('header.txt') }}</p>

                </b-col>
            
            </b-row>

        </b-container>

    </header>

</template>

<script>

    export default {
        
        props: {

            'codigoTraduccion': {
                type: String,
                default: '',
                required: true
            }

        },

    }

</script>

<style lang="scss">
    @import '@/assets/scss/_layout';
</style>